import React from 'react';

const Snowflake: React.FC = () => {
  const size = Math.random() * 10 + 5; // Wielkość płatka (od 5px do 15px)
  const left = Math.random() * 100; // Pozycja startowa w procentach (0% do 100% szerokości ekranu)
  const duration = Math.random() * 5 + 5; // Czas trwania animacji (od 5s do 10s)
  const delay = Math.random() * 5; // Opóźnienie startu (od 0s do 5s)

  const style = {
    width: `${size}px`,
    height: `${size}px`,
    left: `${left}%`,
    animationDuration: `${duration}s`,
    animationDelay: `${delay}s`,
  };

  return <div className="snowflake" style={style}></div>;
};

const SnowfallBackground: React.FC = () => {
  const snowflakes = Array.from({ length: 50 }, (_, i) => (
    <Snowflake key={i} />
  )); // 50 płatków śniegu

  return <div className="snowfall">{snowflakes}</div>;
};

export default SnowfallBackground;
